import {register} from '@shopify/theme-sections';
import Flickity from 'flickity-fade';

register('experts-say', {
  onLoad() {
    const sliderContainer = this.container.querySelector('[data-experts-slider]');

    if(!sliderContainer) return;

    // eslint-disable-next-line no-unused-vars
    const slider = new Flickity(sliderContainer, {
      prevNextButtons: false,
      pageDots: true,
      fade: true,
      autoPlay: true
    });
  }
})